import { pageURLs } from "./pageURLs";

export const BUY = "BUY";
export const SHORT_RENT = "STR";
export const LONG_RENT = "LTR";
export const BUY_LAND = "BUY_LAND";
export const LONG_RENT_LAND = "LTR_LAND";
export const SHORT_RENT_LAND = "STR_LAND";
export const BUY_STRENGTHEN = "BUY_STRENGTHEN";
export const LTR_STRENGTHEN = "LTR_STRENGTHEN";
export const INVENTORY_STRENGTHEN = "INVENTORY_STRENGTHEN";
export const LOT_LAND = "LOT_LAND";
export const SELL = "SELL";
export const USER_TYPE_MEMBER = 1;
export const USER_TYPE_AGENT = 2;
export const REAL_ESTATE_AGENT = 1;
export const PROPERTY_MANAGER = 2;
export const INVESTOR_MEMBER = 2;
export const BASIC_MEMBER = 1;
export const BOTH_TITLE = 3;
export const WANT_AD = "WANT_AD";
export const RESET_PWD_EMAIL_VERIFICATION = "RESET_PWD_EMAIL_VERIFICATION";
export const PROPERTY_AD = "PROPERTY_AD";
export const IS_LAND = 6;
export const IS_OTHER = 7;
export const IS_ENTIRE_SPACE = 10;
export const IS_ENTIRE_PLACE = 10;
export const IS_PRIVATE_ROOM = 11;
export const ADTYPE_BUY = 1;
export const ADTYPE_LTR = 2;
export const ADTYPE_STR = 3;
export const WANT_AD_PAGE_LIMIT = 10;
export const WANT_AD_KEY = "memberBuy";
export const WANT_AD_KEY_TEMP = "memberBuyTemp";
export const WANT_AD_ARRAY_KEY = "wantAdArray";
export const STRENGTHEN_WANT_AD_KEY = "strengthenAd";
export const INVENTORY_KEY = "memberInventory";
export const INVENTORY_KEY_TEMP = "memberInventoryTemp";
export const STRENGTHEN_INVENTORY_KEY = "strengthenInvntry";
export const USER_LOCATION_KEY = "userLocation";
export const RECENT_SEARCHES = "recent_searches";
export const SEARCHED_LOCATION = "searchedLocation";
export const FILTER_QUERY = "filterQuery";
export const SCROLL_DIRECTION_UP = "up";
export const SCROLL_DIRECTION_DOWN = "down";
export const USER_INFO_KEY = "userInfo";
export const CLIENT_DETAILS_KEY = "clientDetails";
export const IS_APARTMENT_CONDO = 2;
export const IS_GUEST_HOUSE = 8;
export const IS_HOUSE = 1;
export const IS_TOWNHOME = 3;
export const IS_MANUFACTURE = 5;
export const IS_MULTI_FAMILY = 4;
export const IS_VILLA = 9;
export const IS_HOTEL = 12;

// RESO property type IDs (new types for Buy Want-Listings)
export const IS_DUPLEX = 14;
export const IS_TRIPLEX = 15;
export const IS_FOURPLEX = 16;
export const IS_VACANT_LAND = 17;
export const IS_AGRICULTURAL = 18;
export const IS_RANCH = 19;
export const IS_UNIMPROVED_LAND = 20;
export const IS_CABIN = 21;
export const IS_FARM = 22;
export const IS_TIMESHARE = 23;
export const IS_MIXED_USE = 24;

// RESO property category IDs
export const PROPERTY_CATEGORY_RESIDENTIAL = 1;
export const PROPERTY_CATEGORY_MULTI_UNIT = 2;
export const PROPERTY_CATEGORY_LAND = 3;
export const PROPERTY_CATEGORY_SPECIALTY = 4;

// Map property type IDs to their category (for inferring category on edit)
export const PROPERTY_TYPE_TO_CATEGORY = {
  1: PROPERTY_CATEGORY_RESIDENTIAL,   // Single-Family
  2: PROPERTY_CATEGORY_RESIDENTIAL,   // Condo/Apartment
  3: PROPERTY_CATEGORY_RESIDENTIAL,   // Townhome
  5: PROPERTY_CATEGORY_RESIDENTIAL,   // Manufactured
  6: PROPERTY_CATEGORY_RESIDENTIAL,   // Land (also in Multi-Unit, default to Residential)
  14: PROPERTY_CATEGORY_MULTI_UNIT,   // Duplex
  15: PROPERTY_CATEGORY_MULTI_UNIT,   // Triplex
  16: PROPERTY_CATEGORY_MULTI_UNIT,   // Fourplex
  4: PROPERTY_CATEGORY_MULTI_UNIT,    // 5+ Units
  17: PROPERTY_CATEGORY_LAND,         // Vacant Land
  18: PROPERTY_CATEGORY_LAND,         // Agricultural
  19: PROPERTY_CATEGORY_LAND,         // Ranch
  20: PROPERTY_CATEGORY_LAND,         // Unimproved Land
  21: PROPERTY_CATEGORY_SPECIALTY,    // Cabin
  22: PROPERTY_CATEGORY_SPECIALTY,    // Farm
  23: PROPERTY_CATEGORY_SPECIALTY,    // Timeshare
  24: PROPERTY_CATEGORY_SPECIALTY,    // Mixed-Use
};

export const ENTIRE_SPACE_TYPE = "entirespace";
export const PRIVATE_ROOM_TYPE = "privateroom";
export const ENTIRE_SPACE_INVENTY_TYPE = "Inv-es";
export const PRIVATE_ROOM_INVENTY_TYPE = "inv-pr";
export const INVENTORY_TYPE = "inventory";
export const IN_CITY_LIMITS = "In city limits";
export const RURAL = "Rural";
export const LOT_TYPES = [
  { value: 1, text: "Rural" },
  { value: 2, text: "In city limits" },
];
export const ROAD_TYPES = [
  { value: 1, text: "City roads" },
  { value: 2, text: "Private drive" },
];
export const WATER_SUPPLY = [
  { value: 1, text: "Domestic water supply" },
  { value: 2, text: "Drilled well" },
];
export const WASTE_WATER_SYSTEM = [
  { value: 1, text: "Sewer" },
  { value: 2, text: "Septic system" },
];
export const YES_NO_OPTIONS = [
  { value: true, text: "Yes" },
  { value: false, text: "No" },
];
export const INVENTORY_ALL_TYPE = "inv";
export const INVENTORY_SELL = "inv_sell";
export const INVENTORY_LTR = "inv_ltr";
export const INVENTORY_STR = "inv_str";
export const INVENTORY_SELL_LTR = "inv_sell_ltr";
export const INVENTORY_SELL_STR = "inv_sell_str";
export const INVENTORY_LTR_STR = "inv_ltr_str";
export const INVENTORY_LAND = "inv_land";
export const MEMBER_INVENTORY_EDIT_KEY = "memberInventoryEdit";
export const AGENT_INVENTORY_CREATE_KEY = "agentInventoryCreate";
export const AGENT_INVENTORY_EDIT_KEY = "agentInventoryEdit";
export const AGENT_WANTAD_KEY = "agentWantAdData";
export const MEMBER_INTRODUCTION = "memberIntroduction";
export const AGENT_INTRODUCTION = "agentIntroduction";
export const PUBLISHED = "PUBLISHED";
export const PAUSED = "PAUSED";
export const DRAFT = "DRAFT";
export const CLOSED_TAB = "Closed";
export const PAUSED_TAB = "Paused";
export const DRAFT_TAB = "Drafts";
export const PUBLISHED_TAB = "Published";
export const INTRODUCTION_ACCEPT = 1;
export const INTRODUCTION_DECLINE = 2;
export const INTRODUCTION_NOT_INTERESTED = 3;
export const INTRODUCTION_NOT_A_FIT = 4;
export const INTRODUCTION_CANCELLED = 5;
export const INTRODUCTION_DECLINE_UNDO = "INTRODUCTION_DECLINE_UNDO";
export const NORMAL_USER_FREE = 1;
export const NORMAL_USER_PREMIUM_MONTHLY = 2;
export const NORMAL_USER_PREMIUM_YEARLY = 3;
export const AGENT_USER_FREE_MEMBER = 4;
export const AGENT_USER_MONTHLY_PRO_MEMBER = 5;
export const AGENT_USER_YEARLY_PRO_MEMBER = 6;
export const ERROR_TEXT = "Invalid input";
export const AGENT_USER_FREE_PLAN = "Lite";
export const MEMBER_USER_FREE_PLAN = "Lite";
export const AGENT_USER_PREMIUM_PLAN = "Pro Member";
export const NORMAL_USER_PREMIUM_PLAN = "Member";
export const HOME_PAGE = "HOME";
export const DEFAULT_MAP_ZOOM = 13;
export const DEFAULT_WANT_AD_MAP_ZOOM = 13;
export const DEFAULT_INVENTORY_MAP_ZOOM = 13;
export const INVENTORY_RT_CITY_ROADS = 1;
export const INVENTORY_RT_PRVT_DRIVE = 2;
export const INVENTORY_WS_DOMESTIC = 1;
export const INVENTORY_WS_DRLLD_WELL = 2;
export const INVENTORY_WWS_SEWER = 1;
export const INVENTORY_WWS_SEPTIC_SYS = 2;
export const STORY_ANY = 1;
export const STORY_SINGLE = 2;
export const YEAR_BUILT_RANGE = 1;
export const NEW_CONSTRUCTION = 2;
export const STR_MIN_BUDGET = 50;
export const MIN_LT_DROPDOWN = "minLtSzDrop";
export const MAX_LT_DROPDOWN = "maxLtSzDrop";
export const NO_MIN_TEXT = "No min lot size"; //"No min";
export const NO_MAX_TEXT = "No max lot size"; //"No max";
export const INVENTORY_MAP_RADIUS = 0.3; // in miles
export const PAGE_LIMIT = 10;
export const DECIMAL_POINTS_IN_COORDICATES = 4;
export const MAP_EVENT_DRAG = "MAP_EVENT_DRAG";
export const MAP_EVENT_MARKER_DRAG = "MAP_EVENT_MARKER_DRAG";
export const MAP_EVENT_CLICK = "MAP_EVENT_CLICK";
export const MAP_EVENT_LOCATION_CHANGE = "MAP_EVENT_LOCATION_CHANGE";
export const DATE_FORMAT_MM_DD_YYYY = "DATE_FORMAT_MM_DD_YYYY";
export const STR_DATE_RANGE = 1;
export const STR_FLEXIBLE_DATE = 2;
export const MAP_TYPE_ROADMAP = "roadmap";
export const MAP_ICON_S3_URL =
  "https://s3.amazonaws.com/gitcha-uploads/Gitcha_images/map-icon-black.png";
export const IMG_JPEG_FORMAT = "image/jpeg";
export const IMG_PNG_FORMAT = "image/png";
export const MEMBER_PREFERENCE_WANTAD = "wantad";
export const MEMBER_PREFERENCE_INVENTORY = "inventory";
export const MEMBER_PREFERENCE_BROWSE = "browse";
export const MEMBER_PREFERENCE_POST_WANTAD = "post_want_ad";
export const INVESTOR_MEMBER_PLAN = "Investor Member";
export const PRO_MEMBER_PLAN = "Pro Member";
export const BUDGET_NOMIN_NOMAX = "No min - No max";

export const PLAN_TYPES = [
  {
    name: "Lite",
    amount: "free",
  },
  // {
  //     name : 'Pro Member',
  //     amount : 'free'
  // },
  {
    name: "Member",
    amount: {
      monthly: 13,
      annual: 10,
    },
  },
  {
    name: "Investor Member",
    amount: {
      monthly: 15,
      annual: 12,
    },
  },
  {
    name: "Pro Member",
    amount: {
      monthly: 15,
      annual: 12,
    },
  },
  {
    name: "Pro Preferred",
    amount: {
      monthly: 75,
      annual: 60,
    },
  },
];

export const WANT_AD_STATUS = [
  { value: 1, text: "Buyer is pending", key: 'pending', successText: 'Buyer is pending' },
  { value: 2, text: "Buyer is pending with contingencies", key: 'pending_with_contigencies', successText: 'Buyer is pending with contingencies' },
  { value: 3, text: "Closed", key: 'closed', successText: 'Your want-listing has been closed.' },
  { value: 4, text: "Pause", key: 'archived', successText: 'Your want-listing has been paused.' },
  { value: 5, text: "Terminated", key: 'terminated', successText: 'Your want-listing has been terminated.' },
];

export const CLOSURE_OUTCOMES = [
  { value: 'purchased', text: 'Purchased a property' },
  { value: 'did_not_purchase', text: 'Did not purchase' },
  { value: 'still_looking', text: 'Still looking' },
];

export const DID_NOT_PURCHASE_REASONS = [
  { value: 'timeline_changed', text: 'Timeline changed' },
  { value: 'budget_changed', text: 'Budget changed' },
  { value: 'relocated', text: 'Relocated' },
  { value: 'found_rental', text: 'Found rental instead' },
  { value: 'client_changed_mind', text: 'Client changed mind' },
  { value: 'other', text: 'Other' },
];

export const HOW_FOUND_OPTIONS = [
  { value: 'bls_match', text: 'Via BLS match' },
  { value: 'own_search', text: 'Own search' },
  { value: 'another_agent', text: 'Another agent' },
  { value: 'other', text: 'Other' },
];

export const PROPERTY_TYPE_OPTIONS = [
  { value: 1, text: 'Single-Family Home' },
  { value: 2, text: 'Condo/Apartment' },
  { value: 3, text: 'Townhome' },
  { value: 5, text: 'Manufactured' },
  { value: 4, text: 'Multi-Family' },
  { value: 14, text: 'Duplex' },
  { value: 15, text: 'Triplex' },
  { value: 16, text: 'Fourplex' },
  { value: 17, text: 'Vacant Land' },
  { value: 21, text: 'Cabin' },
  { value: 22, text: 'Farm' },
  { value: 19, text: 'Ranch' },
];

export const PlanDetails = [
  {
    planName: "Member",
    description: "Unlock features to get the most out of Gitcha for less.",
    features: [
      "Unlimited want-listings",
      "Unlimited properties in your inventory",
      "10 free introductions per month",
    ],
  },
  {
    planName: "Investor Member",
    description:
      "Includes investor specific features to create more opportunities.",
    features: [
      "Property management dashboard",
      "Additional buyer box criteria",
      "Unlimited want-listings",
      "Unlimited properties in your inventory",
      "10 free introductions per month",
      "Custom Investor profile and badge",
    ],
    badge: true,
    badgeText: "INVESTOR",
    isGoldBadge: true,
  },
  {
    planName: "Pro Member",
    description:
      "Specific features for agents and teams to create and manage deals.",
    features: [
      "Client management dashboard",
      "Unlimited want-listings",
      "Unlimited properties in your inventory",
      "10 free introductions per month",
      "Custom agent profile and Pro badge",
      "Branded Buyer Digital Listing Form",
      "See other Premium Agents’ contact info on want listings (coming soon)",
    ],
    badge: true,
    badgeText: "PRO",
    isGoldBadge: false,
  },
];

export const INTRODUCTION_AMOUNT = 3;
export const INTRODUCTION_TAX = 0;

export const NICE_2_HAVES_CATEGORIES_MASTER_LIST = [
  {
    title: 'Lot features',
    category: 'Property',
    placeholder: 'Select lot features'
  },
  {
    title: 'Room & Space features',
    category: 'Layout',
    placeholder: 'Select room & space features'
  },
  {
    title: 'Exterior features',
    category: 'Exterior',
    placeholder: 'Select exterior features'
  },
  {
    title: 'Interior features',
    category: 'Interior',
    placeholder: 'Select interior features'
  },
  {
    title: 'Other features',
    category: 'Other',
    placeholder: 'Select other features'
  },
  {
    title: 'Architectural Style features',
    category: 'Architectural_Style',
    placeholder: 'Select architectural style features'
  },
  {
    title: 'Other Structure features',
    category: 'Other_Structures',
    placeholder: 'Select other structure features'
  },
  {
    title: 'Association Amenities features',
    category: 'Association_Amenities',
    placeholder: 'Select association amenities features'
  },
];

export const NICE_2_HAVES_LOT_LAND_CATEGORIES = [
  {
    title: 'Lot features',
    category: 'Property',
    placeholder: 'Select lot features'
  },
  {
    title: 'Exterior features',
    category: 'Exterior',
    placeholder: 'Select exterior features'
  },
  {
    title: 'Other features',
    category: 'Other',
    placeholder: 'Select other features'
  },
  {
    title: 'Other Structure features',
    category: 'Other_Structures',
    placeholder: 'Select other structure features'
  },
  {
    title: 'Association Amenities features',
    category: 'Association_Amenities',
    placeholder: 'Select association amenities features'
  }, {
    title: 'Views features',
    category: 'Views',
    placeholder: 'Select views features'
  },
]

export const propertyTab = "Property";
export const layoutTab = "Layout";
export const interiorTab = "Interior";
export const exteriorTab = "Exterior";
export const otherTab = "Other";
export const architecturalStyleTab = "Architectural_Style";
export const otherStructuresTab = "Other_Structures";
export const associationAmenitiesTab = "Association_Amenities";
export const viewsTab = "Views";
export const characteristicsTab = "Characteristics";

export const INDEX_TO_BE_SLICE = 25;
export const INDEX_TO_BE_SLICE_15 = 25;
export const MAX_FILE_SIZE = 1000000;

export const MAX_FILES = 20;
export const MIN_WIDHT = 700;
export const MIN_HEIGHT = 400;

export const SLIDER_MIN_VALUE = 1;
export const SLIDER_MAX_VALUE = 10;
export const SLIDER_DEFAULT_VALUE = 10;
export const SLIDER_STEP_VALUE = 0.25;

export const supportedImageFormats = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/heic",
];

export const WANT_AD_KEY_EDIT = "memberWantAdEdit";
export const INTRODUCTION_NOT_A_FIT_FROM_PENDING_LIST = 1;
export const INTRODUCTION_NOT_A_FIT_FROM_ACCEPTED_LIST = 2;

export const INTRODUCTION_EXPIRATION_TIME = 72;
// export const INTRODUCTION_EXPIRATION_TIME = 1; // for testing
export const YEAR_BUILT_MIN = 1900;
export const YEAR_BUILT_MAX = new Date().getFullYear();

export const ACESS_CODE = "accessCode";
export const INAPPNOTIFICATIONCOUNT = "inappNotificationCount";
export const NOTIFICATIONCOUNT = "notificationCount";

export const WANT_AD_BUY_PROPERTY_ID = 13;

export const DISPLAY_TEXT_BUY = "Buy";
export const DISPLAY_TEXT_LTR = "Rent (Long-term)";
export const DISPLAY_TEXT_STR = "Rent (Short-term)";

export const DISPLAY_BUY = "buy";
export const DISPLAY_LTR = "rent";
export const DISPLAT_STR = "stay";
export const DISPLAY_LTR_TIMELINE = "move-in";
export const NOT_FREE_OR_MEMBER_PERIOD = 1;
export const FREE_PLAN = 1;
export const DISPLAY_STR_PPTY_TYPE = "stay in";

export const DISPLAT_RENTAL = "rental";

export const dashBoardActivePageList = [
  pageURLs.proDashboard,
  pageURLs.myWantAds,
];

export const INVENTORY_PURPOSE = {
  Seller: "SELL",
  Long_Term_Rent: "LTR",
  Short_Term_Rent: "STR",
};

export const UNREADCHATMESSAGESCOUNT = "unreadChatMessagesCount";

export const alwLrgDogsChkBx = "alwLrgDogs";
export const alwsmlDogsChkBx = "alwSmlDogs";
export const alwCatsChkBx = "alwCats";
export const alwPetsChkBx = "alwPets";
export const accsPvtBthRmchkBx = "accsPvtBthRm";
export const pvtEntrnceChkBx = "pvtEntrnce";
export const confirmOwnerChkBx = "isConfirmOwner";
export const confirmPropLocChkBx = "isConfirmPropLoc";
export const adaAccessCheckBox = "adaAccess";
export const newConstructionCheckBox = "newConstruction";

export const accsPvtBthRmchkBxFilter = "pvtBath";
export const adaAccessibleChkBx = "adaAccess";
export const MAX_SELECTION_COUNT = 10;
export const MAX_SELECTION_COUNT_16 = 16;

export const DEFAULT_MAX_BUDGET_BUY = 5000000;
export const DEFAULT_MAX_BUDGET_LTR = 7500;
export const DEFAULT_MAX_BUDGET_STR = 5000;

export const DEFAULT_STEP_VALUE_BUY = 25000;
export const DEFAULT_STEP_VALUE_LTR = 100;
export const DEFAULT_STEP_VALUE_STR = 50;
export const PAGE_SIZE = 10;

export const lotSizeOptions = [
  { value: 1, label: "Acres" },
  { value: 2, label: "SQFT" },
];

export const SELL_ASKING_PRICE = "sellAskngPrice";
export const LTR_ASKING_PRICE = "LTRAskngPrce";
export const STR_ASKING_PRICE = "STRAskngPrce";

export const RT_PVT_DRIVE_INSTALL = "isPrvtDrInst";
export const WS_DRILLED_WELL_INSTALL = "isDrldWelInst";
export const WS_DRILLED_WELL_APPRRV = "isDrldWelAppr";
export const WWS_SEPT_TANK_INSTALL = "isSepTankInst";
export const WWS_SEPT_TANK_APPROV = "isSepTankAppr";
export const poweAccessSection = "isPowerAccess";
export const approvedStrctrSection = "isApprovedStrctr";
export const floodPlainSection = "isInFloodPlain";

export const supportedImageFormatsMsgSection = [
  "jpg",
  "jpeg",
  "png",
  "heic",
  "pdf",
  "doc",
  "docx",
];
export const BIO_MAX_COUNT = 2500;

export const PAYMENT_HISTORY_OPTIONS = [
  { value: "last_30", label: "Last 30 days" },
  { value: "last_quarter", label: "Last quarter" },
  { value: "last_year", label: "Last year" },
  { value: "all_time", label: "All time" },
];

export const TESTIMONIAL_MAX_COUNT = 1000;
